export const dateFormatOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
}
export const locale = 'zh-CN';

export default class DateFormatUtils {

    static format(date?: Date): string {
        return date ? new Date(date).toLocaleString(locale, dateFormatOptions) : "";
    }

}